import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { greyScaleColors, semanticColors } from '../../Globals/styles';
import Radium from 'radium';

class EmployeeDragPreview extends Component {
  render() {
		const { employeeName, isActive, isOpen } = this.props;
    return (
      <div style={styles.container}>
        <div
          className="col-xs-12"
          style={[styles.employeeName, isActive && styles.employeeActive, isOpen && styles.employeeOpen]}>
          <div style={styles.dragable}>
            <img src="/images/Drag_and_Drop.png" alt="dragNDrop" />
          </div>
            {employeeName}
          </div>

      </div>
    );
  }
}

var styles = {
	container: {
		width: '232px'
	},
  employeeName: {
    textAlign: 'left',
    marginTop: '12px',
    padding: '0 5px 0 40px',
    backgroundColor: greyScaleColors.greyLighter,
    height: '40px',
    lineHeight: '40px',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    borderTopLeftRadius: '2px',
    borderBottomLeftRadius: '2px'
  },
  employeeActive:{
    backgroundColor: semanticColors.infoLight
  },
  employeeOpen:{
    backgroundColor: semanticColors.mainBackground
  },
  hourButtonContainer:{
    padding: '0',
    marginTop: '12px'
  },
  button: {
    height: '40px',
    padding: '0',
    borderTopLeftRadius: '0',
    borderBottomLeftRadius: '0',
    borderTopRightRadius: '2px',
    borderBottomRightRadius: '2px'
  },
  dragable: {
    position: 'absolute',
    left: '0',
    height: '40px',
    width: '40px',
    textAlign: 'center',
    lineHeight: '40px'
  }
}
	EmployeeDragPreview.propTypes = {
		employeeName: PropTypes.string.isRequired,
		isActive: PropTypes.bool.isRequired,
		isOpen: PropTypes.bool.isRequired
	};
export default Radium(EmployeeDragPreview)


// WEBPACK FOOTER //
// ./src/App/Util/DragPreviews/employeeDragPreview.jsx